export const snapShotToArray = (snapShot) => {
  const array = [];
  snapShot.forEach(docSnapshot => {
	array.push(docSnapshot.data());
  });
  return array;
};

export const queryRefToObject = (queryRef) => queryRef.exists() ? queryRef.data() : {};
